import { render, staticRenderFns } from "./order-selected-stock-grid.vue?vue&type=template&id=13be2cfe&"
import script from "./order-selected-stock-grid.vue?vue&type=script&lang=ts&"
export * from "./order-selected-stock-grid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports